"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetProfileQuery = exports.useUpdateProfileMutation = exports.useVerifyOtpMutation = exports.useSendOtpMutation = exports.useSignupMutation = exports.useSkyAuthSignupMutation = exports.useSkyAuthVerifyOtpMutation = exports.useSkyAuthSendOtpMutation = exports.useLoginMutation = exports.authApi = void 0;
// api/authApi.ts
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.authApi = (0, react_1.createApi)({
    reducerPath: "authApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.API_URL || "http://localhost:7002"),
    tagTypes: ["auth"],
    endpoints: function (builder) { return ({
        login: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/user/log_in",
                method: "POST",
                body: obj,
            }); },
            invalidatesTags: ["auth"],
        }),
        // Sky Lifestyle Auth Endpoints (NEW)
        skyAuthSendOtp: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/sky-auth/send-otp",
                method: "POST",
                body: obj,
            }); },
        }),
        skyAuthVerifyOtp: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/sky-auth/verify-otp",
                method: "POST",
                body: obj,
            }); },
        }),
        skyAuthSignup: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/sky-auth/signup",
                method: "POST",
                body: obj,
            }); },
            invalidatesTags: ["auth"],
        }),
        // Legacy MongoDB Endpoints (DEPRECATED)
        signup: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/user/sign_up",
                method: "POST",
                body: obj,
            }); },
            invalidatesTags: ["auth"],
        }),
        sendOtp: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/user/send_otp",
                method: "POST",
                body: obj,
            }); },
        }),
        verifyOtp: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/user/verify_otp",
                method: "POST",
                body: __assign(__assign({}, obj), { client_entity_id: obj.client_entity_id || "lewfin_providers" }),
            }); },
            invalidatesTags: ["auth"],
        }),
        // Update Profile Endpoint
        updateProfile: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/user/update-profile",
                method: "PUT",
                body: obj,
            }); },
            invalidatesTags: ["auth"],
        }),
        // Get Profile Endpoint
        getProfile: builder.query({
            query: function () { return ({
                url: "/v1/user/profile",
                method: "GET",
            }); },
            providesTags: ["auth"],
        }),
    }); },
});
exports.useLoginMutation = exports.authApi.useLoginMutation, 
// Sky Lifestyle Auth Hooks (NEW)
exports.useSkyAuthSendOtpMutation = exports.authApi.useSkyAuthSendOtpMutation, exports.useSkyAuthVerifyOtpMutation = exports.authApi.useSkyAuthVerifyOtpMutation, exports.useSkyAuthSignupMutation = exports.authApi.useSkyAuthSignupMutation, 
// Legacy MongoDB Hooks (DEPRECATED)
exports.useSignupMutation = exports.authApi.useSignupMutation, exports.useSendOtpMutation = exports.authApi.useSendOtpMutation, exports.useVerifyOtpMutation = exports.authApi.useVerifyOtpMutation, 
// Profile Management
exports.useUpdateProfileMutation = exports.authApi.useUpdateProfileMutation, exports.useGetProfileQuery = exports.authApi.useGetProfileQuery;
